import { render, staticRenderFns } from "./InjuryInsuranceAdjustmentDataTable.vue?vue&type=template&id=b2f65df6&scoped=true"
import script from "./InjuryInsuranceAdjustmentDataTable.vue?vue&type=script&lang=js"
export * from "./InjuryInsuranceAdjustmentDataTable.vue?vue&type=script&lang=js"
import style0 from "./InjuryInsuranceAdjustmentDataTable.vue?vue&type=style&index=0&id=b2f65df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f65df6",
  null
  
)

export default component.exports